import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className='header'>
            <h3>Study with proper time management</h3>

        </div>
    );
};

export default Header;